module.exports = "<div class=redirect> <loading-screen model=redirect.loading messages=redirect.widgetLoadingScreens></loading-screen> </div> ";